



































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator';
import {MediaObject} from '@/modules/media/types'
import FileSelector from '@/modules/media/components/FileSelector.vue'

/**
 * Selector de imagen
 *
 * Widget que permite al usuario seleccionar una imagen
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        FileSelector,
    },
})
export default class ImageSelect extends Vue {
    @Prop({type: Boolean, default: false})
    public outlined: boolean

    @Prop({type: Boolean, default: false})
    public denseToolbar: boolean

    public image = new MediaObject()

    /**
     * Valor del selector
     *
     * Imagen actualmente seleccionada por el usuario
     */
    @Prop({type: MediaObject, default: () => new MediaObject()})
    public value: MediaObject

    @Watch('value')
    public onValueChange (value: MediaObject) {
        this.image = value
    }

    /**
     * Título de la tarjeta que alberga el componente
     */
    @Prop({type: String, default: 'Seleccionar imagen'})
    public title: string

    public fileSelector = false

    /**
     * Indica si existe alguna imagen válida seleccionada
     */
    public get hasImage (): boolean {
        return !!this.image.id
    }

    /**
     * Elimina la imagen actualmente mostrada
     */
    public resetImage () {
        this.$emit('input', this.image = new MediaObject())
    }

    public onImageSelect (image: MediaObject) {
        this.image = image
        this.$emit('input', image)
        this.fileSelector = false
    }

    public created () {
        this.image = this.value
    }
}
